import { Modal } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useAddNewSubFolder from '../../hooks/useAddnewsubFolder';
const Reuploader = ({
  reUploadModal,
  setReuploadModal,
  setLastUploadData,
  differenceData,
  lastUploadData,
}) => {
  const addANewFile = useAddNewSubFolder();

  function arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele?.name !== value?.name;
    });
  }

  const location = useLocation();

  useEffect(() => {
    if (differenceData?.length === 0) {
      setReuploadModal(false);
      setLastUploadData([]);
    }
    // eslint-disable-next-line
  }, [lastUploadData?.length]);

  return (
    <Modal
      opened={reUploadModal}
      onClose={() => {
        setReuploadModal(false);
        setLastUploadData([]);
      }}
      title={'Error to Upload'}
      //   withCloseButton={false}
      overlayColor={'#F8F7F799'}
      overlayBlur={20}
      overlayOpacity={0.5}
      centered
      size={500}
      radius='md'
      overflow='inside'
      transitionDuration={100}
      classNames={{
        title: 'w-full text-center text-[#D0342C]  font-semibold text-18',
        modal: 'pl-10',
        body: 'scroller -mr-4 pr-2',
      }}
    >
      <p className='text-[#D0342C] text-sm font-semibold text-center'>
        The file/files with this name already exists.
        <br />
        Would you like to add this new file/files,
        <br />
        or rename it and keep them both?
      </p>
      <div className='flex flex-col my-5'>
        {differenceData?.map((each) => (
          <div className='flex justify-between items-center'>
            <p>{each?.name}</p>
            <div>
              <button
                className='mx-1 my-1'
                onClick={() => {
                  const formData = new FormData();
                  formData.append('file', each);
                  formData.append('path', location?.state?.path);
                  formData.append('replace', true);
                  formData.append('force_upload', true);
                  addANewFile.mutate(formData);
                  setLastUploadData(arrayRemove(lastUploadData, each));
                }}
              >
                <SecondaryButton>Replace</SecondaryButton>
              </button>
              <button
                className='mx-1 my-1'
                onClick={() => {
                  const formData = new FormData();
                  formData.append('file', each);
                  formData.append('path', location?.state?.path);
                  formData.append('replace', false);
                  formData.append('force_upload', true);
                  addANewFile.mutate(formData);
                  setLastUploadData(arrayRemove(lastUploadData, each));
                }}
              >
                <PrimaryButton>Keep both</PrimaryButton>
              </button>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default Reuploader;
